<template>
    <o-card :shadow="shadow" :sync-page-title="syncPageTitle" :title="title">
        <slot name="meta" :item="data.meta"></slot>
        <slot name="filter" class="mb-3"></slot>

        <template v-if="data.data.length === 0">
            {{ $t('core.no_records') }}
        </template>
        <template v-else>
            <div class="row justify-content-start pb-1 pt-1 font-weight-bold ml-0 mr-0">
                <slot name="head"></slot>
            </div>
            <div v-for="(item) in data.data" class="row justify-content-start border-top pb-1 pt-1 ml-0 mr-0">
                <slot :item="item" name="body">
                    no controls for body slot specified
                </slot>
            </div>
        </template>
        <template slot="footer">
            <o-pagination :data="data.meta.pagination" class="mt-5" v-on:change-page="changePage"></o-pagination>
        </template>
    </o-card>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
    name: 'o-div-table',

    props: {
        url: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        syncPageTitle: {
            type: Boolean,
            default: true
        },
        shadow: {
            type: Boolean,
            default: true
        }
    },

    data: () => ({
        data: {
            data: [],
            meta: {
                pagination: {
                    current_page: 1
                }
            },
            filters: [],
            sortBy: 'id',
            sortByDirection: 'asc'
        }
    }),

    computed: {},

    methods: {
        changePage(page) {
            this.data.meta.pagination.current_page = page
            this.search()
        },
        search() {
            this.$root.$loading.start()

            axios
                .get(this.url, {
                    paramsSerializer: qs.stringify,
                    params: {
                        page: this.data.meta.pagination.current_page,
                        filter: this.filters,
                        sortBy: this.sortBy,
                        sortByDirection: this.sortByDirection
                    }
                })
                .then((response) => {
                    this.data = response.data
                    this.$root.$loading.finish()
                    this.$emit('loaded', this.data)
                })
                .catch((error) => {
                    this.$root.$loading.finish()
                    console.log(error)
                    window.alert('could not load data from ' + this.url)
                })
        },
        setFilters(filters) {
            var flatFilters = {}
            filters.forEach((item) => {
                flatFilters[item.column] = item.value
            })
            this.filters = flatFilters
            this.search()
        },
        sortColumn(options) {
            this.sortBy = options.column
            this.sortByDirection = options.direction

            // let all table header components know what column we sort by, we need this to activate the correct indicator
            // and also clear the previous sorted column indicator
            this.$slots.head.forEach((item) => {
                if (item && item.componentOptions && item.componentOptions.tag === 'o-table-header') {
                    item.componentInstance.setSortProperties(this.sortBy, this.sortByDirection)
                }
            })

            this.search()
        },
        deleteUrl() {
            let url = this.url
            // Always strip query strings for DELETE operations
            let splitUrl = url.split('?')
            if (Array.isArray(splitUrl) && splitUrl.length && 0 in splitUrl) {
                return splitUrl[0]
            }
            return url
        }
    },
    mounted() {
        this.search()
        this.$on('sort-column', this.sortColumn)
    }
}

</script>
